import { ITeamBoardPivotContext } from "Agile/Scripts/BoardsHub/BoardsHubContracts";
import { component } from "Agile/Scripts/Common/Components/ComponentRegistration";
import { DynamicPivotItem } from "Agile/Scripts/Common/Components/DynamicPivotItem";
import { LoadingComponent } from "Presentation/Scripts/TFS/Components/LoadingComponent";
import { IContributedPivotProps } from "VSSPreview/Utilities/PivotContributions";
import * as React from "react";

export interface IBoardPivotProps extends IContributedPivotProps<ITeamBoardPivotContext, {}> { }

@component("work.boardshub.analytics")
export class BoardAnalyticsPivotRegistration extends React.Component<IBoardPivotProps> {
    public render(): JSX.Element {
        const { pivotContext } = this.props;

        return (
            <DynamicPivotItem
                dataProviders={[]}
                shouldReloadDataProviders={pivotContext.shouldReloadDataProviders}
                modules={["Agile/Scripts/BoardsHub/AnalyticsPivot/BoardAnalyticsPivot"]}
                onRenderLoading={() => <LoadingComponent />}
                componentProps={pivotContext}
                componentKey="boards-analytics-pivot"
            />
        );
    }
}
